import React, {Component} from "react";
import {AsyncTypeahead} from 'react-bootstrap-typeahead'
import {Query} from 'react-apollo'
import {gql} from 'apollo-boost'
import PropTypes from 'prop-types'

import 'react-bootstrap-typeahead/css/Typeahead.css';

const QUERY = gql`
query search_project_disciplines($query: String){
  search_project_disciplines(description: $query){
    project_discipline_id
    description
  }
}`

export default class ProjectDisciplinesTypeahead extends Component{


    constructor(props){
        super(props)
        this.state = {
            isLoading: false,
            selected: props.selected || [],
            query: ''
        }
    }

    onChange = (selectedOptions) => {
        this.setState({selected: selectedOptions})
        this.props.onChange(selectedOptions)
    }


    render(){

        const {
            selected
        } = this.state

        console.log('selected', selected)

        return (<Query query={QUERY} variables={{query: this.state.query}}>
            {({ loading, data: { search_project_disciplines } }) => {
                return (
                    <AsyncTypeahead
                        {...this.props}
                        bsSize="sm"
                        labelKey="description"
                        minLength={0}
                        multiple
                        onSearch={(query) => this.setState({query})}
                        onChange={this.onChange}
                        isLoading={loading}
                        options={search_project_disciplines}
                        selected={selected}
                    />)
            }}

        </Query>)
    }
}

ProjectDisciplinesTypeahead.propTypes = {
    onChange: PropTypes.func.isRequired,
    selected: PropTypes.array
}